import { render } from "./RecentObjectsListItem.vue?vue&type=template&id=3f97ec3c"
import script from "./RecentObjectsListItem.vue?vue&type=script&lang=js"
export * from "./RecentObjectsListItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__